// Re-export API types from the service layer
export type {
  RangePlanningItem,
  RangePlanningItemListResponse,
  CreateRangePlanningItemRequest,
  ItemSupplierDetail,
  ItemUomConversion,
  ItemPricing,
  ItemCatalogueAvailability,
  ItemRecipeUsageRef,
  ItemInventoryMapping,
} from '../../app/services/api/rangePlanningItems/rangePlanningItemsTypes';

export { ItemLifecycleStatus } from '../../app/services/api/rangePlanningItems/rangePlanningItemsTypes';

// UI-only types
export enum ItemDetailTab {
  Overview = 'overview',
  SupplierDetails = 'supplier-details',
  UomConversions = 'uom-conversions',
  Pricing = 'pricing',
  AllergensAttributes = 'allergens-attributes',
  Nutrition = 'nutrition',
  CarbonSustainability = 'carbon-sustainability',
  CatalogueAvailability = 'catalogue-availability',
  RecipeUsage = 'recipe-usage',
  InventoryMapping = 'inventory-mapping',
}
